import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  IconButton,
  Typography,
  Grid,
  Paper,
  Button,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LambdaFetch from '../functions/FetchFromLambda';
import LoadingButton from '../components/LoadingButton';
import { actransCols, actransMoreCols } from '../constants/ActivityCols';
import TableMui from '../components/TableMui';
import getTableOptions from '../constants/TableOptions';
import DialogTable from '../components/DialogTable';
import { smallScreenWidth } from '../constants/AppConstants';
import { ServerSideTable } from '../components/ServerSideTable';
import ReactTableServerSide from '../components/ReactTableServerSide';
import { useActransReactTableCols } from '../hooks/ActivityCols';
import { DashboardAthenaTableServerSide } from '../components/DashboardAthenaTableServerSide'
import { DashboardAthenaTableServerSideNoSelect } from '../components/DashboardAthenaTableServerSideNoSelect'
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
import fetchFromAthena from '../functions/FetchFromAthena'
import ReactTable from '../components/ReactTable'
import LoadingCircle from '../components/common/LoadingCircle'
import DateInput from '../components/DateInput'
import OpenSearchDropdown from '../components/OpenSearchDropdown'
import HardCodedDropdown from '../components/HardCodedDropdown'

const _ = require('lodash');

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem',
  },
  treeRoot: {
    flexGrow: 1,
    margin: '1rem',
  },
}));

const defaultHeaders = {
  fiscalYear: '',
  period: '',
  company: '',
  activity: '',
  activityGrp: '',
  acctCategory: '',
  fromDate: '',
  toDate: '',
};

export default function Actrans(props) {
  const [state, setstate] = useState({
    isLoading: false,
    data: null,
    tableKey: JSON.stringify(defaultHeaders),
  });
  const [showTable, setShowTable] = useState(false);
  const [headers, setHeaders] = useState(defaultHeaders);
  const [clearHeader, setClearHeaders] = React.useState(false);
  const [clearTrigger, setClearTrigger] = React.useState(false);
  const [moreInfo, setMoreInfo] = useState(null);
  const [showHeaders, setShowHeaders] = useState(false);
  const [tableById, setTableById] = useState({
    isOpen: false,
    data: null,
    isLoading: false
  });

  const classes = useStyles();

  const actransReactTableCols = useActransReactTableCols();

  const { credentials } = props.fetchInitialData;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const type = urlParams.get('type');
    if (id && type) {
      // getActivity({id,type})
      setTableById({
        ...tableById,
        isOpen: true,
        isLoading: false,
        id,
          type
      });
    } else {
      setShowHeaders(true);
    }
  }, []);

  const getActivity = async ({id, type}) => {
    setTableById({ ...tableById, isLoading: true });
    try {

      const data = await fetchFromAthena({
        queryName: 'activity_read',
        headers: {
          id,
          type
        },
        accessToken: credentials.user.accessToken,
        credentials: credentials
      })
      setTableById({
        ...tableById,
        isOpen: true,
        data: data,
        isLoading: false,
      });
    } catch (e) {
      setstate({ ...state, isLoading: false });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (JSON.stringify(headers) === state.tableKey) return null;
    setShowTable(true);
    setstate({ ...state, isLoading: true, tableKey: JSON.stringify(headers) });
  };

  const fetchTranData = async (params) => {
    setstate({ ...state, isLoading: true });

    try {
      const resp = await LambdaFetch(
        'actrans',
        'post',
        credentials.user.accessToken,
        JSON.stringify({
          action: 'get-actrans',
          ...params,
        }),
        '',
        credentials
      );
      const actransData = tableDataTransformation(resp.data.actrans);

      setstate({
        ...state,
        data: actransData,
        isLoading: false,
      });
    } catch (e) {
      console.log(e);
      setstate({ ...state, isLoading: false });
    }
  };
  const tableDataTransformation = (data) => {
    return data.map((row) => {
      row['MORE'] = (
        <div className="editLink" onClick={() => setMoreInfo([row])}>
          view
        </div>
      );
      return row;
    });
  };
  const handleCallback = (values, error) => {
    if (error) {
      setstate({ ...state, isLoading: false });
      setShowTable(false);
      return null;
    }
    setstate({ ...state, isLoading: false });
  };

  const options = getTableOptions({ cols: actransCols, fileName: `actrans` });
  options.downloadOptions.filterOptions.useDisplayedColumnsOnly = false;

  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <DialogTable
        isOpen={!!moreInfo}
        handleClose={() => setMoreInfo(null)}
        tableData={moreInfo}
        cols={actransMoreCols}
        title={`${moreInfo && moreInfo[0].ACTIVITY}`}
        simpleTable
        noFooter
      />

      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size="small"
        onClick={() => props.history.push('/')}
        aria-label="delete"
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant="h5" style={{ textAlign: 'center' }}>
        AC Trans By Period
      </Typography>
      <div className={classes.root}>
        {showHeaders && (
          <Paper elevation={0} style={{ padding: '1rem' }}>
            <form onSubmit={handleSubmit}>
              <Grid
                container
                alignContent="center"
                alignItems="flex-start"
                spacing={3}
              >
                <Grid item>
                  <OpenSearchDropdown
                    id='fiscalYear'
                    required
                    width='125px'
                    label='Year'
                    page="ACTIVITY"
                    entity="YEAR"
                    searchFields={['DISPLAY']}
                    accessToken={credentials.user.accessToken}
                    credentials={credentials}
                    clearTrigger={clearTrigger}
                    onChange={(val) => {
                      setHeaders({ ...headers, fiscalYear: val?.VALUE || null })
                    }}
                  />
                </Grid>
                <Grid item>
                  <HardCodedDropdown
                    id='period'
                    required
                    width='125px'
                    label='Period'
                    dataset="PERIOD"
                    clearTrigger={clearTrigger}
                    onChange={(val) => {
                      setHeaders({ ...headers, period: val?.VALUE || '' })
                    }}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                alignContent="center"
                alignItems="flex-start"
                spacing={3}
              >
                <Grid item>
                  <OpenSearchDropdown
                    id='company'
                    required
                    disabled={!(headers.fiscalYear && headers.period)}
                    width='125px'
                    label='Company'
                    page="ACTIVITY"
                    entity="COMPANY"
                    searchFields={['DISPLAY']}
                    accessToken={credentials.user.accessToken}
                    credentials={credentials}
                    clearTrigger={clearTrigger}
                    onChange={(val) => {
                      setHeaders({ ...headers, company: val?.VALUE || null })
                    }}
                  />
                </Grid>
                <Grid item>
                  <OpenSearchDropdown
                    id='activity'
                    required={false}
                    disabled={!(headers.fiscalYear && headers.period)}
                    width='125px'
                    label='Activity'
                    page="ACTIVITY"
                    entity="ACTIVITY"
                    searchFields={['DISPLAY']}
                    accessToken={credentials.user.accessToken}
                    credentials={credentials}
                    clearTrigger={clearTrigger}
                    // filters={{
                    //   YEAR: headers.fiscalYear,
                    //   PERIOD: headers.period,
                    //   COMPANY: headers.company
                    // }}
                    onChange={(val) => {
                      setHeaders({ ...headers, activity: val?.VALUE || null })
                    }}
                  />
                </Grid>
                <Grid item>
                  <OpenSearchDropdown
                    id='activityGrp'
                    required={false}
                    disabled={!(headers.fiscalYear && headers.period)}
                    width='125px'
                    label='Activity Group'
                    page="ACTIVITY"
                    entity="ACTIVITYGROUP"
                    searchFields={['DISPLAY']}
                    accessToken={credentials.user.accessToken}
                    credentials={credentials}
                    clearTrigger={clearTrigger}
                    // filters={{
                    //   YEAR: headers.fiscalYear,
                    //   PERIOD: headers.period,
                    //   COMPANY: headers.company
                    // }}
                    onChange={(val) => {
                      setHeaders({ ...headers, activityGrp: val?.VALUE || null })
                    }}
                  />
                </Grid>
                <Grid item>
                  <OpenSearchDropdown
                    id='acctCategory'
                    required={false}
                    disabled={!(headers.fiscalYear && headers.period)}
                    width='125px'
                    label='Acct Category'
                    page="ACTIVITY"
                    entity="ACCTCATEGORY"
                    searchFields={['DISPLAY']}
                    accessToken={credentials.user.accessToken}
                    credentials={credentials}
                    clearTrigger={clearTrigger}
                    // filters={{
                    //   YEAR: headers.fiscalYear,
                    //   PERIOD: headers.period,
                    //   COMPANY: headers.company
                    // }}
                    onChange={(val) => {
                      setHeaders({ ...headers, acctCategory: val?.VALUE || null })
                    }}
                  />
                </Grid>
                {[
                  {
                    id: 'fromDate',
                    label: 'From Date',
                  },
                  {
                    id: 'toDate',
                    label: 'To Date',
                  },
                ].map((field) => {
                  return (
                    <Grid key={field.id} item>
                      <DateInput
                        id={field.id}
                        key={clearHeader}
                        type={'date'}
                        required={false}
                        label={field.label}
                        value={headers[field.id]}
                        onChange={(e) => {
                          setHeaders({
                            ...headers,
                            [field.id]: !!e.target.value
                              ? e.target.value
                              : null,
                          });
                        }}
                        variant="standard"
                        width="160px"
                      />
                    </Grid>
                  );
                })}
              </Grid>

              <div style={{ marginTop: '1rem' }}>
                <LoadingButton
                  label="Submit"
                  disabled={!(headers.fiscalYear && headers.acctPeriod)}
                  isLoading={state.isLoading}
                  color="primaryVLButton"
                  buttonType="submit"
                />
                {!!(
                  headers.fiscalYear ||
                  headers.period ||
                  headers.activity ||
                  headers.activityGrp ||
                  headers.acctCategory ||
                  headers.company ||
                  headers.fromDate ||
                  headers.toDate
                ) && (
                  <Button
                    onClick={() => {
                      setClearHeaders(!clearHeader);
                      setHeaders(defaultHeaders);
                      setShowTable(false);
                      setClearTrigger(prev => !prev);
                      setstate({
                        ...state,
                        data: null,
                        tableKey: JSON.stringify(defaultHeaders)
                      });
                    }}
                    style={{ marginLeft: '0.5rem' }}
                  >
                    Clear
                  </Button>
                )}
              </div>
            </form>
          </Paper>
        )}

        {/* {tableById.isLoading && (
          <LoadingCircle />
        )} */}
        {tableById.isOpen && (
          <div style={{ marginTop: '1rem ' }}>
             <DashboardAthenaTable
              {...props}
              isTempTable={true}
              key={state.tableKey}
              params={ tableById }
              tableColumns={actransReactTableCols}
              reportParamName="activity_read"
              reportName='activity_read_temp'
              tableTitle={''}
              transform={tableDataTransformation}
              callback={handleCallback}
              downloadFileName={'Actrans_Download'}
            />
          </div>
        )}

        {showTable && (
          <div style={{ marginTop: '1rem ' }}>
            <DashboardAthenaTable
              {...props}
              isTempTable={true}
              key={state.tableKey}
              params={{ ...headers }}
              tableColumns={actransReactTableCols}
              reportParamName="actrans_read_serverside"
              reportName='actrans_read_serverside_temp'
              tableTitle={''}
              transform={tableDataTransformation}
              callback={handleCallback}
              downloadFileName={'Actrans_Download'}
            />
          </div>
        )}
      </div>
    </div >
  );
}
